import { render, staticRenderFns } from "./AuthorityBox.vue?vue&type=template&id=d3a2552c&"
import script from "./AuthorityBox.vue?vue&type=script&lang=js&"
export * from "./AuthorityBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports